import { ComponentType } from "react";
import { LANGUAGE } from "_constants";
import { ReactComponent as WhistleIcon } from "./assets/whistle.svg";
import { ReactComponent as RallyIcon } from "./assets/rally.svg";
import { ReactComponent as AceIcon } from "./assets/ace.svg";
import { ReactComponent as AtBatIcon } from "./assets/at-bat.svg";
import { ReactComponent as HitIcon } from "./assets/hit.svg";
import { ReactComponent as SingleIcon } from "./assets/single.svg";
import { ReactComponent as PitchingChangeIcon } from "./assets/pitching-change.svg";
import { ReactComponent as StolenBaseIcon } from "./assets/stolen-base.svg";
import { ReactComponent as WalkIcon } from "./assets/walk.svg";

const MESSAGES_EN: Record<string, string> = {
  "1240": "Start",
  "1211": "Hit",
  "1212": "Single",
  "1217": "Ball",
  "1218": "Strike",
  "1219": "Foul",
  "1243": "Undo",
  "1244": "End of Match",
  "1245": "Strike Out",
  "1254": "??",
  "2201": "At Bat",
  "2203": "Home Run",
  "2206": "Walk",
  "2207": "Out",
  "2208": "Stolen Base",
  "2210": "Pitching Change",
  "2211": "End of Inning",
  "2212": "Start of Inning",
  "1226": "End of Half Inning",
};

const MESSAGES_ALB: Record<string, string> = { ...MESSAGES_EN };

export const MESSAGES = {
  [LANGUAGE.ENGLISH]: MESSAGES_EN,
  [LANGUAGE.ALBANIAN]: MESSAGES_ALB,
};

export const ICONS: Record<string, ComponentType<any>> = {
  "1244": WhistleIcon,
  "1240": WhistleIcon,
  "1245": RallyIcon,
  "1211": HitIcon,
  "1212": SingleIcon,
  "1217": AceIcon,
  "1218": RallyIcon,
  "1219": RallyIcon,
  "2201": AtBatIcon,
  "2203": SingleIcon,
  "2206": WalkIcon,
  "2207": RallyIcon,
  "2208": StolenBaseIcon,
  "2210": PitchingChangeIcon,
  "2211": WhistleIcon,
  "2212": WhistleIcon,
  "1226": WhistleIcon,
};
